import { createContext, ReactNode, useCallback, useState } from "react";

export const LoaderContext = createContext({
    open: false,
    toggle: () => {},
});

export const LoaderContextProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const [open, setOpen] = useState(false);

    const toggle = useCallback(() => {
        setOpen((prev) => !prev);
    }, []);

    return (
        <LoaderContext.Provider
            value={{
                open,
                toggle,
            }}
        >
            {children}
        </LoaderContext.Provider>
    );
};
